export default withFieldValidation;
/**
 * @type {function(this: import('flightjs').ComponentAPI<
 * { fieldSelector: string, requiredFields: string, requiredCheckboxes: string },
 * { ensureFieldsArePopulated: Function, hideErrors: Function, setErrorMessageForField: Function }
 * >): void}
 */
function withFieldValidation() {
    this.attributes({
        fieldSelector: '[data-field]',
        requiredFields: '[data-field-required]',
        requiredCheckboxes: '[data-checkbox-required]',
    });
    this.ensureFieldsArePopulated = function() {
        var valid = true;
        this.select('requiredFields').each(
            function(i, elm) {
                elm = $(elm);
                if (elm.val().trim() === '') {
                    valid = false;
                    this.setErrorMessageForField(elm, elm.data('field-required'));
                }
            }.bind(this)
        );

        this.select('requiredCheckboxes').each(
            function(i, elm) {
                elm = $(elm);
                if (!elm.is(':checked')) {
                    valid = false;
                    this.setErrorMessageForField(elm, elm.data('checkbox-required'));
                }
            }.bind(this)
        );

        return valid;
    };

    this.hideErrors = function() {
        this.select('fieldSelector').removeAttr('data-field-error');
        this.select('[data-error-message]').attr('data-hidden', true);
        this.select('[data-validation]').text('');
    };

    // Each validated field should have <div data-validation="fieldId"></div>
    // 'data-field-error' is added to parent field container as styling hook
    this.setErrorMessageForField = function(fieldNode, message) {
        var selector = '[data-validation="' + fieldNode.attr('id') + '"]';
        this.$node.find(selector).html(message);
        fieldNode.parents(this.attr.fieldSelector).attr('data-field-error', true);
    };
}



// WEBPACK FOOTER //
// ./src/js/flight/mixins/with-field-validation.js